var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressoesEAmeacas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "152.38944 135.15492 153.29652000000002 200.46468000000002",
    xmlSpace: "preserve",
    style: {
      maxHeight: 500
    },
    y: "0px",
    x: "0px",
    id: "Camada_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.29652000000002,
    height: 200.46468000000002,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 453.54,
    width: 453.54,
    id: "SVGID_9_"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 453.54,
    width: 453.54,
    id: "SVGID_11_"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,203.15c-1.59-2.95-3.43-5.76-4.66-8.82c-1.41-3.52-2.28-7.25-3.36-10.9     c-0.14-0.46-0.13-0.98-0.12-1.47c0.13-5.48,3.57-7.41,8.27-4.58c4.22,2.55,7.22,6.33,9.82,10.41c1.62,2.54,3,5.24,4.39,7.92     c0.46,0.88,0.9,1.21,1.85,0.86c0.75-0.27,1.54-0.46,2.32-0.62c5-1.03,7.62,0.14,10,4.7c1.17,2.23,2.2,4.56,3.05,6.93     c0.55,1.53,1.39,1.8,2.88,1.69c13.66-0.96,26.21,2.38,37.39,10.3c13.61,9.64,21.75,22.84,24.38,39.29     c4.06,25.45-7.67,50.07-29.82,63.04c-32.53,19.05-74.83,2.15-85.04-34.15c-6.36-22.61-1.19-42.65,14.46-60.03     c1-1.12,1.13-1.88,0.45-3.18c-1.56-2.94-3.01-5.94-4.37-8.98c-1.87-4.19-1.05-6.99,2.81-9.52     C200.24,204.94,202.11,204.1,203.88,203.15 M265.87,298.42c5.56,0.11,10.9-0.88,15.16-4.7c13.59-12.19,11.69-31.37-0.44-42.88     c-1.28-1.22-2.9-1.79-4.57-0.8c-1.65,0.98-2.01,2.49-1.91,4.43c0.22,4.35,0.72,8.82,0.01,13.06     c-1.55,9.31-6.03,17.36-12.29,24.42c-0.49,0.55-0.96,1.13-1.36,1.75c-1.35,2.1-0.39,4.34,2.07,4.69     C263.63,298.55,264.76,298.42,265.87,298.42",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.53,148.06c-0.46,5.48-1.54,10.72-3.91,15.6c-0.71,1.46-1.75,2.86-2.94,3.97     c-1.84,1.72-4.13,1.15-5.1-1.15c-0.49-1.17-0.84-2.48-0.92-3.74c-0.4-6.67,0.93-13,4-18.93c0.58-1.12,1.42-2.19,2.37-3.03     c1.98-1.76,4.29-1.28,5.2,1.2C214.94,143.9,215.12,146.02,215.53,148.06",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,182.26c2.48,0.4,5,0.66,7.44,1.24c1.75,0.42,3.5,1.28,3.73,3.38c0.24,2.14-1.39,3.17-2.98,4.05     c-3.81,2.11-8.03,2.86-12.29,3.02c-3.05,0.12-6.13-0.34-9.19-0.55c-0.3-0.02-0.61-0.11-0.9-0.22c-1.74-0.68-3.62-1.32-3.81-3.55     c-0.18-2.14,1.45-3.18,3.05-4.01C165.93,183.24,170.99,182.62,176.2,182.26",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,180.13c-7.18-1.21-14.13-4.45-19.7-10.4c-0.53-0.57-0.9-1.33-1.19-2.07     c-0.82-2.11,0.13-4.05,2.36-4.23c2.05-0.16,4.21-0.03,6.2,0.48c5.26,1.34,9.96,3.92,14.17,7.34c0.81,0.66,1.53,1.44,2.19,2.25     c1.11,1.38,2.08,2.9,1.25,4.73C190.14,180.16,188.27,180.08,185.72,180.13",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.23,146.91c0.31-1.43,0.45-2.93,0.97-4.27c0.76-1.96,2.6-2.51,4.41-1.44c0.83,0.49,1.64,1.15,2.21,1.93     c4.62,6.24,6.95,13.25,6.84,21.04c-0.01,0.55-0.1,1.11-0.24,1.64c-0.83,3.21-3.46,4.16-5.79,1.83c-1.67-1.66-3.05-3.72-4.16-5.81     C185.92,157.01,184.52,151.32,184.23,146.91",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,177.6c-3.65,0.02-5.11-2.16-3.66-5.14c0.56-1.15,1.31-2.26,2.18-3.19     c4.48-4.76,9.79-8.26,16.09-10.11c1.21-0.35,2.57-0.46,3.82-0.34c2.35,0.23,3.41,2.02,2.6,4.24c-0.33,0.91-0.78,1.83-1.39,2.58     c-4.63,5.74-10.57,9.53-17.61,11.63C215.92,177.52,215.1,177.54,214.64,177.6",
    className: "st1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressoesEAmeacas);
export default __webpack_public_path__ + "static/media/pressoes-e-ameacas.52f8df9a82a894162e4628932b2d4191.svg";
export { ForwardRef as ReactComponent };